module.exports = __webpack_public_path__ + "static/media/timeoutBerry.c172cb91.svg";